/*
    模块组件
    ChenYN

    说明
    发现页/直播

    版本
    1.0

    传参
        name Sting : 当前页面的name(同路由)
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <SignLiveStream></SignLiveStream>
*/
<template>
    <div class="live_stream">
        <div class="scroll_wrapper">
            <div class="refresh_wrap">
                <span v-if="isRefreshing"><Loading color="#333" size="24px">加载中...</Loading></span>
                <span v-else>{{refreshTxt}}</span>
            </div>


            <div class="live_stream_content">
                <live-box type = "list" :item= "item" v-for="item in onLives" :key="item"></live-box>

                <div class="live_stream_content_be_live">
                    <div class = "title">即将开始</div>
                    <!-- <a href = "javascript:;" @click = "goState({name: 'gameupdatalog' })" class = "more_btn">更多>></a> -->
                    <div class="live_stream_content_be_live_box" v-for="item in beLives" :key="item">
                        <span class="live_stream_content_be_live_box_item" @click="jumpShow(item)">
                            <img class="bg" :src="item.cover" />
                            <p class="img">
                                <img :src="item.avatar" />
                            </p>
                            <p class="name">{{ item.name }}</p>
                            <p class="dec">{{ formatTime(item) }}</p>
                        </span>
                    </div>
                </div>
            </div>

            <div class="refresh_bottom">我是有底线</div>
        </div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, onActivated, onDeactivated , computed } from 'vue';
import { Button, ImagePreview, Loading, Popup, Icon  } from "vant"
import router from "@/router"
import store from "@/store"
import Util from '@/assets/js/lib/util';
import BScroll from '@better-scroll/core'
import Pulldown from '@better-scroll/pull-down'
import ObserveImage from '@better-scroll/observe-image'
BScroll.use(Pulldown)
BScroll.use(ObserveImage)
import LiveBox from '@/components/Seven_LiveBox/LiveBox.vue';

export default defineComponent({
    name: 'SignLiveStream',
    components: { Button, ImagePreview, Loading, Popup, Icon, LiveBox },
    props: {
        name: {
            type: String,
            default: 'index'
        }
    },
    setup(props) {
        const state = reactive({
            util: new Util(),
            icons: computed(() => store.state.icons),
            userInfo: computed(() => store.state.userInfo),
            bs: '',
            isRefreshing: false, //是否正在刷新中
            refreshTxt: '下拉刷新', //下拉刷新提示文字
            onLives: [], //直播中
            beLives: [] //将直播
        });

        const data = reactive({
            liveLists: [], // 直播中列表
            beLiveLists: [], // 稍后直播列表
        });

        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            swipeChange: (e) => state.currentPageIndex = e,
            viewSwipe: (index = 0) => {
                ImagePreview({
                    startPosition: index,
                    images: computed(() => { let arr = []; data.bannerList.map(v => arr.push(v.url)); return arr;}),
                    closeable: true,
                });
            },
            formatTime: (item) => {
                switch (item.type) {
                    case 2:
                        return `每天${item.plan}直播`;
                    case 1:
                        let time = new Date(item.plan).getTime();
                        return `下次直播 ${state.util.timestampToTimeChinese(time)}`;
                    default:
                        break;
                }
            },
            jumpShow: (item) => {
                state.util.winOpen(item.homepage);
            }
        }; //需要对外暴露的方法

        onMounted(async () => {
            await refresh();
            initScroll();
        });

        onActivated(async () => {
            if (new Util().Cookie().get("access_token")) {
                await refresh();
                state.openBoxFlag = false;
                if(state.bs == ''){
                    initScroll();
                }
            }
        })

        onDeactivated(() => {
            window.Components.toast.clear();
        })

        const initScroll = () => { //初始化上下滚动
            state.bs = new BScroll('.live_stream',{
                scrollY: true,
                click: true,
                probeType: 2,
                bounceTime: 400,
                swipeBounceTime: 400,
                outOfBoundaryDampingFactor: 0.6,
                pullDownRefresh: {
                    threshold: 50,
                    stop: 40 //这样就会回到顶部了
                },
                deceleration: 0.009,
                observeImage: true
            })

            state.bs.on('scroll',  (position) => {
                if(position.y < 38){
                    state.refreshTxt = '下拉刷新';
                    state.isRefreshing = false;
                    state.bs.finishPullDown();
                }else {
                    state.refreshTxt = '释放刷新'
                }
            });

            state.bs.on('pullingDown', async () => {

                state.isRefreshing = true;
                state.page = 1;
                state.total = 1;

                await refresh();

                setTimeout(() => {
                    window.Components.toast('刷新成功');
                    state.bs.finishPullDown();
                    state.bs.refresh();
                }, 300);
            });

            setTimeout(() => {
                state.bs.refresh();
            }, 100);
        };

        const refresh = async () => { //页面数据
            const res = await state.util.getJson('/live', 'GET', {}, true);
            if(res.code == 0){
                state.onLives = res.data.live;
                state.beLives = res.data.list;
            }else {
                window.Components.toast(res.msg)
            }
        };


        return {
            ...toRefs(state),
            ...methods,
        };
    },
});
</script>

<style lang="less" scoped>
@charset "utf-8";
@import "./LiveStream.less";
</style>
